import React from 'react'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import DocSigningNavUI from '../../../components/superUser/loan/DocSigningNavUI'
import AddendumSignSF from '../../../components/superUser/loan/document/AddendumSignSF.js'
import LoanPropertyListSF from '../../../components/superUser/loan/util/LoanPropertyListSF.js'

const AddendumPageUI = ({ context, errorList, loan, onRefreshClick, onAddAddendum }) =>
  <SuperUserLoanPageUI context={context} className='pg_su_loan_a_lst'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList} loan={loan} page='esigning'
  >
    {
      (!loan || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <IconButtonUI icon='icon-plus' onClick={onAddAddendum} />
              <span className='g_m_left_100 g_large'><b>Addendum</b></span>
            </span>
          }
          right={<span />}
        />
        <DocSigningNavUI loan={loan} page='addendum' />

        <AddendumSignSF context={context} loan={loan}
          onRefreshClick={onRefreshClick}
        />

        <LoanPropertyListSF context={context} loan={loan} category='addendum' categoryLabel='Addendum tokens' />
      </div>
    }
  </SuperUserLoanPageUI>

export default AddendumPageUI
